import { apiFetch } from "./api";

interface CountResponse {
  count: number;
}

export const outstandingCountsKeys = {
  emails: ["outstanding-counts", "emails"] as const,
  enquiries: ["outstanding-counts", "enquiries"] as const,
};

export const outstandingCounts = {
  /**
   * Returns the number of outstanding job emails.
   * The backend endpoint /api/jobs/emails/outstanding/count returns 0 by
   * contract — v2 has no "unactioned inbound email" predicate yet. When that
   * predicate is defined, only the server handler needs to change.
   */
  async emails(): Promise<number> {
    const body = await apiFetch<CountResponse>("/api/jobs/emails/outstanding/count");
    return body.count;
  },

  /** Returns the count of open (Status = "New") enquiries. */
  async enquiries(): Promise<number> {
    const body = await apiFetch<CountResponse>("/api/enquiries/outstanding/count");
    return body.count;
  },
};
